import * as XLSX from 'xlsx';
import axios from 'axios';
import dayjs from 'dayjs';

//将excel的日期格式转成Date()对象;
const getFormatDate = (serial: number, by: string = '-') => {
  if (!serial) {
    return null;
  }
  var utc_days = Math.floor(serial - 25569);
  var utc_value = utc_days * 86400;
  var date_info = new Date(utc_value * 1000);
  var fractional_day = serial - Math.floor(serial) + 0.0000001;
  var total_seconds = Math.floor(86400 * fractional_day);
  var seconds = total_seconds % 60;
  total_seconds -= seconds;
  var hours = Math.floor(total_seconds / (60 * 60));
  var minutes = Math.floor(total_seconds / 60) % 60;
  var d = new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);

  var add0 = (m: number) => (m < 10 ? `0${m}` : m);
  var YYYY = d.getFullYear();
  var MM = add0(d.getMonth() + 1);
  var DD = add0(d.getDate());
  return `${YYYY}${by}${MM}${by}${DD}`;
};

const tryFormatDate = (stringDate) => {
  const formatList = [
    'YYYY-M-D',
    'YYYY-M-DD',
    'YYYY-MM-D',
    'YYYY-MM-DD',

    'D-M-YYYY',
    'DD-M-YYYY',
    'D-MM-YYYY',
    'DD-MM-YYYY',

    'M-D-YYYY',
    'M-DD-YYYY',
    'MM-D-YYYY',
    'MM-DD-YYYY',

    'YYYY/M/D',
    'YYYY/M/DD',
    'YYYY/MM/D',
    'YYYY/MM/DD',

    'D/M/YYYY',
    'DD/M/YYYY',
    'D/MM/YYYY',
    'DD/MM/YYYY',

    'M/D/YYYY',
    'M/DD/YYYY',
    'MM/D/YYYY',
    'MM/DD/YYYY',

    'YY-M-D',
    'YY-M-DD',
    'YY-MM-D',
    'YY-MM-DD',

    'D-M-YY',
    'DD-M-YY',
    'D-MM-YY',
    'DD-MM-YY',

    'M-D-YY',
    'M-DD-YY',
    'MM-D-YY',
    'MM-DD-YY',

    'YY/M/D',
    'YY/M/DD',
    'YY/MM/D',
    'YY/MM/DD',

    'D/M/YY',
    'DD/M/YY',
    'D/MM/YY',
    'DD/MM/YY',

    'M/D/YY',
    'M/DD/YY',
    'MM/D/YY',
    'MM/DD/YY',
  ];
  if (stringDate === undefined || stringDate === null || stringDate.length === 0) {
    return stringDate;
  }
  let valueString = stringDate;

  for (let index = 0; index < formatList.length; index++) {
    const format = formatList[index];
    if (dayjs(stringDate, format, true).isValid()) {
      const dayStr = dayjs(stringDate).format('YYYY/MM/DD');
      if (new Date('1970-01-01').getTime() < new Date(dayStr).getTime()) {
        valueString = dayStr;
      }
      break;
    }
  }

  return valueString;
};

// 读取示例 可根据需求自定义 startLine表示从第几行（从1开始计算）开始是有效数据，通常该行是header的变量名
const readResponse = (res: any, startLine = 3, skipDate = false) => {
  const sheets = Object.keys(res);
  const group: any = {};

  sheets.forEach((sheet) => {
    group[sheet] = [];
    const headers = res[sheet][startLine - 1];
    for (let index = startLine; index < res[sheet].length; index++) {
      const element = res[sheet][index];
      if (!element || element.length === 0) {
        continue;
      }
      const item: any = {};
      for (let j = 0; j < headers.length; j++) {
        if (headers[j]) {
          const header = String(headers[j]).trim();
          if (
            !skipDate &&
            typeof element[j] === 'number' &&
            (header.match('Date') || header.match('時期') || header.match('日付') || header.match('date') || header.match('day'))
          ) {
            item[header] = getFormatDate(element[j]);
          } else {
            item[header] = typeof element[j] === 'string' ? element[j].trim() : element[j];
          }
        }
      }
      group[sheet].push(item);
    }
  });
  return group;
};

// Convert JSON to Excel buffer data
const jsonToExcelBuffer = (workSheetList: { jsonData: any; sheetName: string }[]) => {
  const workBook = XLSX.utils.book_new();
  for (let index = 0; index < workSheetList.length; index++) {
    const workSheetData = workSheetList[index];
    const workSheet = XLSX.utils.json_to_sheet(workSheetData.jsonData);
    XLSX.utils.book_append_sheet(workBook, workSheet, workSheetData.sheetName);
  }
  const excelBuffer = XLSX.write(workBook, { bookType: 'xlsx', type: 'buffer' });
  return excelBuffer;
};

const readBuffer = async (buffer: any) => {
  try {
    const ret: any = {};

    const wb = XLSX.read(buffer, { type: 'array', cellStyles: true });

    wb.SheetNames.forEach((name: string) => {
      const sheet: any = wb.Sheets[name];
      ret[name] = XLSX.utils.sheet_to_json(sheet, { header: 1 });
    });

    return ret;
  } catch (error) {
    console.error('读取文件失败：', error);
  }
};

// 读取excel文件
const readExcelFile = async (filePath: string) => {
  try {
    const response = await axios.get(filePath, { responseType: 'arraybuffer' });
    const buffer = new Uint8Array(response.data);
    return readBuffer(buffer);
  } catch (error) {
    console.error('读取文件失败：', error);
  }
};

const readBufferWithStyles = async (buffer: any) => {
  const getCellColor = (sheet, cellAddress) => {
    const cell = sheet[cellAddress];
    if (!cell || !cell.s || !cell.s.fgColor) {
      return null;
    }
    return cell.s.fgColor.rgb;
  };

  try {
    const ret: any = {};

    const wb = XLSX.read(buffer, { type: 'array', cellStyles: true });

    wb.SheetNames.forEach((name: string) => {
      const sheet = wb.Sheets[name];

      const json = XLSX.utils.sheet_to_json(sheet, {
        header: 'A',
        blankrows: false,
        raw: false,
      });

      // 遍历所有单元格
      for (const cellAddress in sheet) {
        if (cellAddress[0] === '!') continue; // 跳过特殊的元数据单元格

        // 获取单元格的背景色
        const cellColor = getCellColor(sheet, cellAddress);

        // 获取单元格的行列
        const cellRow = XLSX.utils.decode_cell(cellAddress).r;
        const cellCol = XLSX.utils.decode_cell(cellAddress).c;

        // 合并背景色到 JSON 数据中
        const header = XLSX.utils.encode_col(cellCol);

        if (json[cellRow] === null || json[cellRow] === undefined) continue; // 跳过

        // 自动转日期会出现很多奇怪的问题 要求提供的excel的日期格式准确
        const valueString = json[cellRow][header]; //tryFormatDate(json[cellRow][header]);

        if (cellColor) {
          json[cellRow][header] = {
            value: valueString,
            bgColor: cellColor,
          };
        } else {
          json[cellRow][header] = {
            value: valueString,
          };
        }
      }
      ret[name] = json;
    });
    return ret;
  } catch (error) {
    console.error('读取文件失败：', error);
  }
};

const readExcelFileWithStyles = async (filePath: string) => {
  try {
    const response = await axios.get(filePath, { responseType: 'arraybuffer' });
    const buffer = new Uint8Array(response.data);
    return readBufferWithStyles(buffer);
  } catch (error) {
    console.error('读取文件失败：', error);
  }
};

const readSheetResponse = (sheet: any, startLine = 3) => {
  const resp = [];
  const headers = sheet[startLine - 1];
  for (let index = startLine; index < sheet.length; index++) {
    const element = sheet[index];
    if (!element || element.length === 0) {
      continue;
    }
    const item: any = {};
    for (let j = 0; j < headers.length; j++) {
      if (headers[j]) {
        const header = headers[j].trim();
        if (header.match('Date') || header.match('時期') || header.match('日付') || header.match('date') || header.match('day')) {
          item[header] = getFormatDate(element[j]);
        } else {
          item[header] = typeof element[j] === 'string' ? element[j].trim() : element[j];
        }
      }
    }
    resp.push(item);
  }
  return resp;
};

export {
  jsonToExcelBuffer,
  readExcelFile,
  getFormatDate,
  readBuffer,
  readResponse,
  readBufferWithStyles,
  readExcelFileWithStyles,
  readSheetResponse,
};
